<template>
  <transition name="fade">
    <div v-show="isshowp6" class="pruanjianpan p6 showcontainervue z106">
      <div class="bantouminghei"></div>
      <div class="p4_1">
        <yuimg class="width100" src="4/p4_1cc.png?v=233"></yuimg>
      </div>
    </div>
  </transition>
</template>
<script>
import { mapState } from "vuex";
import {
  resourcepath,
  commonswiper,
} from "../commonjs/commonfn.js";
import $ from "jquery";
import store from "@/store/";
export default {
  name: "p6",
  data() {
    return {};
  },
  watch: {
    isshowp6(val) {
      if (val == 1) {
        this.initpage();
      } else {
        this.destroypage();
      }
      console.log(val);
    },
  },
  components: {},

  beforeMount() { },
  mounted() {

  },

  methods: {
    initpage() {
      console.log("弹出页面");
    },
    destroypage() {
      console.log("消失页面");
    },
    resload() {
      console.log('资源加载完成');
    },
    refresh() {
      // 刷新页面加载的逻辑 清除组件data 和初始化组件即可
    }
  },
  computed: {
    ...mapState(["isalljiazai", "isshowp6"]),
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/p6.vue